import { getFromLocalStorageAndDecrypt } from "../Helpers/Chat/webChatEncryptDecrypt"
import { updateTheme } from "../Redux/feature/themeDataSlice"
import { store } from "../Redux/store"
import { MirrorFlyTheme, darkTheme } from "./Colors"
import ColorSetTheme from "./ColorSetTheme"
import { cssData } from "./cssDataSet"
import { defaultMirrorFlyIcons } from "./iconDataSet"
// import { MirrorFlyGreenTheme } from "../../stories/initial/colorSet"

export default (theme,iconSet={}) => {
    const colorSet = store.getState()?.customTheme?.theme
    const constructedColorSet = colorSet ? colorSetToCss(colorSet) : {}
    const memoryTheme = themeChecker(theme)
    const setTheme =  (memoryTheme && memoryTheme === 'dark' ? darkTheme : MirrorFlyTheme)
    ColorSetTheme(setTheme, constructedColorSet)
    iconSet && setIconsSets(iconSet)    
}

const colorSetToCss = (colorSetObj) => {
    let colorSet = {}
    let userColorSet = colorSetObj
    let userColorArr = Object.keys(colorSetObj)
    userColorArr.forEach((ele, ind) => {
        if (cssData[ele] && userColorSet[ele] !== "" ) {
            colorSet[cssData[ele]] = userColorSet[ele]
            return true
        }
    })
    return colorSet
}

const themeChecker = (clientTheme) => {
    const localStgTheme = getFromLocalStorageAndDecrypt("themeMode") 
    if(localStgTheme === 'light' || localStgTheme === 'dark'){
        store.dispatch(updateTheme(localStgTheme))
        return localStgTheme
    }else{
        return clientTheme
    }
}
export const setIconsSets=(iconSetObj = defaultMirrorFlyIcons)=>{
    return iconSetObj
}
